"use client";

import { useState } from "react";
import { FiltersMenuItemGender } from "@components/filters-menu/filters-menu-items/filters-menu-item-gender";
import { FiltersMenuItemOrder } from "@components/filters-menu/filters-menu-items/filters-menu-item-order";
import { useBase64QueryState } from "@repo/next-shared/utils/nuqs-custom-parsers";
import { useTranslations } from "next-intl";
import { FiltersMenuItemBrand } from "@components/filters-menu/filters-menu-items/filters-menu-item-brand";
import { FilterMenuItemPrice } from "@components/filters-menu/filters-menu-items/filter-menu-item-price";
import DrawerSidebar from "@repo/ui/components/ui/drawer-sidebar";
import { FiltersMenuItemColors } from "@components/filters-menu/filters-menu-items/filters-menu-item-colors";
import { FiltersMenuItemSizes } from "@components/filters-menu/filters-menu-items/filters-menu-item-sizes";
import FiltersChips from "@components/filters-menu/filters-chips";

export default function FiltersSidebar() {
  const t = useTranslations("Products-list.filters");

  const [filters, setFilters] = useBase64QueryState(null, {
    history: "push",
    shallow: false,
  });

  const [tempFilters, setTempFilters] = useState(filters);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const submitFilters = async () => {
    await setFilters(tempFilters);
    setDrawerOpen(false);
  };

  const applyFilters = (filter: any) => {
    setTempFilters((prev: any) => ({
      ...prev,
      ...filter,
      pageNumber: 0,
    }));
  };

  const clearFilters = async () => {
    await setFilters({
      ...filters,
      sortByDesc: null,
      sortByAsc: null,
      colorId: [],
      size: [],
      brand: [],
      minPrice: null,
      maxPrice: null,
      pageNumber: 0,
      gender: [],
    });
    setDrawerOpen(false);
  };

  return (
    <DrawerSidebar
      labels={{
        trigger: t("filter_order"),
        title: t("filter_order"),
        clear: t("cancel"),
        submit: t("show"),
      }}
      actions={{
        clear: clearFilters,
        submit: submitFilters,
      }}
      drawerOpen={drawerOpen}
      setDrawerOpen={setDrawerOpen}
    >
      <div className="p-10 pb-[60px] mt-10">
        <section className="md:hidden">
          <FiltersChips />
        </section>
        <div className="">
          <FiltersMenuItemOrder
            initialValue={
              filters?.sortByDesc || filters?.sortByAsc
                ? filters?.sortByDesc === "minVariantTargetPrice"
                  ? "desc"
                  : "asc"
                : "none"
            }
            applyFilter={(data: any) => applyFilters(data)}
          />
          <FiltersMenuItemBrand
            initialValue={filters?.brand}
            applyFilter={(data: any) => applyFilters(data)}
          />
          <FiltersMenuItemSizes
            applyFilter={(data: any) => applyFilters(data)}
            initialValue={filters?.size}
          />
          <FiltersMenuItemColors
            applyFilter={(data: any) => applyFilters(data)}
            initialValue={filters?.colorId}
          />
          <FiltersMenuItemGender
            initialValue={filters?.gender}
            applyFilter={(data: any) => applyFilters(data)}
          />
          <FilterMenuItemPrice
            applyFilter={(data: any) => applyFilters(data)}
            defaultValue={[0, 4000]}
            initialValue={[filters?.minPrice || 0, filters?.maxPrice || 4000]}
            max={4000}
            min={0}
          />
        </div>
      </div>
    </DrawerSidebar>
  );
}
